module.exports = __webpack_public_path__ + "static/media/covid-19.ba612136.jpg";